import React, { FC, useEffect, useRef, useState } from "react";
import { Styled } from "./FilterOptionsMenu.styled";
import { AddIcon } from "../../icons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  handleFilter,
  handleFilteringRules,
} from "../../app/store/overlaps/overlaps.slice";
import { generateFilterArr } from "../../utils/helpers/filterHelpers/filterHelpers";
import { FilterOptionsItem } from "./components";
import { selectOverlaps } from "@sdge-store/overlaps/overlaps.selector";
import {
  filterOverlapsData,
  sortOverlapsData,
} from "@sdge-store/overlaps/overlaps.async";

const OverlapsFilterOptionsMenu: FC = () => {
  const [error, setError] = useState(false);
  const { columnDefs, currentFilter, sortingRules, filteringRules } =
    useAppSelector(selectOverlaps);
  useEffect(() => {
    if (
      currentFilter.some(
        (item) => item.errorMessage && item.operation !== "empty"
      )
    ) {
      setError(true);
    } else {
      setError(false);
    }
  }, [currentFilter]);
  const dispatch = useAppDispatch();
  const listEnd = useRef<any>();

  const scrollToBottom = () => {
    listEnd.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [currentFilter?.length]);

  const validColumns = columnDefs
    .filter(({ field }) => field)
    .filter(({ filtering }) => filtering);

  const applyFilterHandler = () => {
    if (currentFilter?.length > 0) {
      const trimmedCurrentFilter = currentFilter.map((item) => {
        return { ...item, value: item.value.trim() };
      });
      dispatch(filterOverlapsData([0, sortingRules, trimmedCurrentFilter]));
      dispatch(handleFilteringRules(trimmedCurrentFilter));
    }
  };

  return (
    <Styled.FilterOptionsWrapper
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <Styled.FilterOptionsList>
        {currentFilter.map((item, index) => (
          <FilterOptionsItem
            key={index}
            field={item.fieldName}
            index={index}
            relation={item.relation}
            negate={item.negate}
            operation={item.operation}
            columnDefs={columnDefs}
            currentFilter={currentFilter}
            filteringRules={filteringRules}
            sortingRules={sortingRules}
            handleFilter={handleFilter}
            filterData={filterOverlapsData}
            sortData={sortOverlapsData}
            handleFilteringRules={handleFilteringRules}
            pageName="overlapping"
          />
        ))}
        <Styled.ListBottom ref={listEnd}></Styled.ListBottom>
      </Styled.FilterOptionsList>
      <Styled.AddFilterWrapper>
        <Styled.FilterButton
          icon={AddIcon}
          title="Add filter"
          onClick={() =>
            dispatch(
              handleFilter(
                generateFilterArr(
                  currentFilter,
                  validColumns[0].filterField || validColumns[0].field,
                  currentFilter
                )
              )
            )
          }
        />
        {currentFilter?.length > 0 && (
          <>
            <Styled.FilterButton
              title="Apply filter"
              isActive
              onClick={applyFilterHandler}
              disabled={error}
            />
            <Styled.DecorateButton
              onClick={(e) => {
                e.preventDefault();
                applyFilterHandler();
              }}
              type="submit"
            />
          </>
        )}
      </Styled.AddFilterWrapper>
    </Styled.FilterOptionsWrapper>
  );
};

export default OverlapsFilterOptionsMenu;
